document.addEventListener('DOMContentLoaded', function() {
  const instagramIcon = document.querySelector('.header-social-icon');
  const headerActions = document.querySelector('header-actions');
  const mobileMenu = document.querySelector('.header-mobile-menu'); // verifica o seletor correto do menu hambúrguer

  function updateInstagramPosition() {
    if (!instagramIcon || !headerActions || !mobileMenu) return;

    if (window.innerWidth <= 749) {
      if (!mobileMenu.contains(instagramIcon)) {
        mobileMenu.appendChild(instagramIcon);
      }
    } else {
      if (!headerActions.contains(instagramIcon)) {
        headerActions.appendChild(instagramIcon);
      }
    }
  }

  window.addEventListener('resize', updateInstagramPosition);
  updateInstagramPosition();
});
